import { AfterContentInit, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { YearPortion, Year } from '../../models';
import { EventsHubService } from '../../../core/events-hub.service';
import { RmsUtilsService } from '../../../core/services';


/**
 * Component class for the quarter picker
 */
@Component({
    selector: 'rms-quarter-picker',
    templateUrl: './quarter-picker.component.html',
    styleUrls: ['./quarter-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QuarterPickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class QuarterPickerComponent implements OnInit, AfterContentInit, ControlValueAccessor {

  private _placeholder: string;
  get placeholder(): string {
    return this._placeholder;
  }

  @Input() set placeholder(value: string) {
    this._placeholder = value;
  }
  @Input() yearsList: Array<Year>;
  @Input() position: string;
  @Input() initialValue: string;
  @Input() initAsEmpty: boolean;
  @Output() onSelectedDateRange: EventEmitter<string> = new EventEmitter<string>();
  public displayValueYear: string;
  public invalidDateRange = true;
  public isEmpty = true;
  public startDate = ['', ''];
  propagateChange = (_: any) => {};

  constructor(
    private eventsHubService: EventsHubService,
    private utilsService: RmsUtilsService,
    private cd: ChangeDetectorRef
  ) {
    this.displayValueYear = '';
  }

  ngOnInit() {
  }

  ngAfterContentInit () {
    if (!this.yearsList) {
      this.yearsList = this.utilsService.generateYearList();
    }
    // In case component is inside a modal, waits for animation modal completes and picker field exists
    setTimeout(() => {
      if (this.initialValue) {
        if (this.initialValue.length <= 4) {
          this.quarterSelected({selected: true, name: this.initialValue.substring(0, 2)});
          this.startDate[1] = this.initialValue.substring(2, 4);
        } else {
          const initialValue = this.initialValue.split(' ');
          this.quarterSelected({selected: true, name: initialValue[0] + ' '});
          this.startDate[1] = initialValue[1];
        }
      }
      this.propagateChange(this.startDate.join(''));
      if (this.initAsEmpty) {
this.isEmpty = true;
} else {
this.isEmpty = false;
}
      this.cd.detectChanges();
    }, 10);
  }

  /**
   * Listen for child component event on select year
   * Populates the year of the quarter data
   * @param evt
   */
  public onYearSelected (evt: Year): void {
    if ( this.startDate[0].length <= 2 ) {
      this.displayValueYear = String(evt.year).slice(-2);
    } else {
      this.displayValueYear = String(evt.year);
    }
    this.startDate[1] = String(evt.year).slice(-2);
    this.validateDateRange();
  }

  /**
   * Clears the quarter picker data
   * @param notifyChange: send true if wants to detect model change when the value is cleared programmatically
   */
  public resetDateRange (notifyChange?: boolean): void {
    this.eventsHubService.resetQuarterPicker();
    this.isEmpty = true;
    this.invalidDateRange = true;
    for (let i = 0; i < this.startDate.length; i++) {
      this.startDate[i] = '';
    }
    this.propagateChange(this.startDate.join(''));
    if (notifyChange) {
      this.setDateRange(true);
    }
    this.cd.detectChanges();
  }

  /**
   * Populates the first part of the start and end date of the quarter data
   * @param {YearPortion} evt
   */
  public quarterSelected (evt: YearPortion) {
    this.startDate[0] = evt.value ? evt.value + ' ' : evt.name;
    if ( evt.value && this.startDate[1].length <= 2 ) {
      this.displayValueYear = '20' + this.startDate[1];
    } else if ( !evt.value ) {
      this.displayValueYear = this.startDate[1];
    }
    this.validateDateRange();
  }

  /**
   * Watches for the date range is valid to enable the "ok" button
   */
  private validateDateRange () {
    if (this.startDate[0] && this.startDate[1]) {
      this.invalidDateRange = false;
    }
    this.cd.detectChanges();
  }

  /**
   * On click "ok" button, passes the quarter picker data to the parent component
   */
  public setDateRange (isEmpty?: boolean): void {
    const dateRange = this.startDate.join('');
    this.onSelectedDateRange.emit(dateRange);
    this.propagateChange(dateRange);
    this.isEmpty = isEmpty;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(value: string): void {
    if (value !== undefined) {
      this.initialValue = value;
    }
  }

}
